var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "40px",
    viewBox: "0 0 29 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Side-bv-Side",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Documents-1.0",
    transform: "translate(-124.000000, -475.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "File_Scroll",
    transform: "translate(80.000000, 445.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PDF-Icon",
    transform: "translate(44.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0771149,0.25 L0.25,0.81 L0.81,39.75 L28.75,39.19 L28.75,10.9969564 L23.7037167,5.94610371 L18.0771149,0.25 Z",
    id: "Rectangle",
    stroke: "#5A5A5A",
    strokeWidth: 0.5,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4545455,0 L18.4545455,8.87735978 C18.5244219,10.070231 19.1497024,10.6666667 20.3303868,10.6666667 C21.5110713,10.6666667 24.4009424,10.6666667 29,10.6666667",
    id: "Path-4",
    fill: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5272179,14.832018 C15.7886575,14.9474883 15.7302838,15.1222713 15.6439653,15.9438143 C15.5551628,16.7950136 15.2601894,18.3453447 14.6907356,19.8672815 C14.1206608,21.3911113 13.2748635,22.8865467 12.5377406,23.995188 C11.8018597,25.1025674 11.1709272,25.8225218 10.6908969,26.2377102 C10.2083826,26.6528986 9.87490745,26.763321 9.65693766,26.8011801 C9.44083087,26.8390393 9.34271342,26.8011801 9.28433974,26.6907577 C9.22596607,26.5803352 9.20547318,26.3941946 9.2557739,26.1739806 C9.30483263,25.9512428 9.42220097,25.6925388 9.75505512,25.3619024 C10.0910142,25.0293731 10.6405962,24.6236495 11.4075269,24.2437963 C12.1744576,23.865836 13.1562531,23.5143772 13.9629276,23.2752337 C14.7696021,23.0348283 15.3980506,22.9061072 15.9482536,22.8051496 C16.4996985,22.7035609 16.9710349,22.6297356 17.4324353,22.5931385 C17.8950777,22.5552793 18.3477842,22.5552793 18.7899337,22.5931385 C19.2320833,22.6297356 19.6649178,22.7035609 20.0387578,22.7944228 C20.4119767,22.8871777 20.7268219,22.9982311 21.0019234,23.174276 C21.2764038,23.349059 21.5130035,23.5894644 21.6303719,23.8570022 C21.7496032,24.125171 21.7496032,24.4204722 21.6508648,24.6324833 C21.5527473,24.8444944 21.3552704,24.9744774 21.1298487,25.0470407 C20.9044269,25.120866 20.6485764,25.1391646 20.3436671,25.0470407 C20.0387578,24.9549168 19.6835477,24.7523705 19.3109498,24.4835707 C18.9383519,24.2166639 18.5446401,23.8853966 18.0335599,23.3679886 C17.5224798,22.8505805 16.8927893,22.1476628 16.3624583,21.4655676 C15.8321272,20.7822104 15.3980506,20.1177827 15.1030773,19.5549437 C14.8093459,18.9914738 14.6516128,18.5302234 14.5236875,18.0677111 C14.3957622,17.6064608 14.2976448,17.1452105 14.258522,16.7300221 C14.2193992,16.3135717 14.2380291,15.9444453 14.2777729,15.651037 C14.3168957,15.3544739 14.3771323,15.133629 14.4746288,14.9859784 C14.5727462,14.8376969 14.7112285,14.7638716 14.8093459,14.7272744 C14.9074634,14.6894153 14.967079,14.6894153 15.0254527,14.6812125 C15.0838264,14.6723787 15.1422001,14.6534491 15.2322446,14.6812125 C15.3179421,14.7064519 15.4322054,14.7771223 15.5272179,14.832018 L15.5272179,14.832018 Z",
    id: "Shape",
    stroke: "#E00101",
    strokeWidth: 0.5
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/PDF-Icon.77016477.svg";
export { ForwardRef as ReactComponent };